import { useEffect, useState } from 'react';
import { ExtraTableResize } from '../../extraTableResize';
import TableComponent from '../../TableComponent';

interface IProps {
  dataSeihin: any[];
  rowIndex: number;
  changeRowIndex: (rowIndex: number) => void; // 行を選択する
}

const ProductSearchTable: React.FC<IProps> = (props: IProps) => {
  const columnInit: any = [
    {
      title: '製品名',
      dataIndex: 'nam',
      width: 200,
      ellipsis: true,
    },
    {
      title: '製品コード',
      dataIndex: 'cd',
      width: 100,
      ellipsis: true,
    },
    {
      title: 'セット',
      dataIndex: 'setKbn',
      width: 100,
      ellipsis: true,
    },
  ];

  const [columns, changeColumns] = useState(columnInit);
  const [rIdx, changeRowIndex] = useState(-1);

  useEffect(() => {
    if (rIdx >= 0) {
      props.changeRowIndex(rIdx);
      changeRowIndex(-1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rIdx]);

  return (
    <>
      <ExtraTableResize>
        <TableComponent
          columns={columns}
          data={props.dataSeihin}
          minHeight="35vh"
          maxHeight="35vh"
          updateColumns={changeColumns}
          rowIndex={rIdx}
          changeRowIndex={changeRowIndex}
        />
      </ExtraTableResize>
    </>
  );
};
export default ProductSearchTable;
